import * as s from "./outline.module.css";

export const outline = {
  none: s.none,
  onFocus: s.onFocus,
  onClassActive: s.onClassActive,
  active: s.active,
  onDataHighlighted: s.onDataHighlighted,
};
